import { render } from "./ExhibitionTicket.vue?vue&type=template&id=dd67ed50&scoped=true"
import script from "./ExhibitionTicket.vue?vue&type=script&lang=js"
export * from "./ExhibitionTicket.vue?vue&type=script&lang=js"

import "./ExhibitionTicket.vue?vue&type=style&index=0&id=dd67ed50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd67ed50"]])

export default __exports__